/* ST · Popup « -10 % pour entrer dans le Monde à l'Envers » (strangerthings-shop.fr) — remplace l'app EcomSend.
   Comportement copié de l'app (popup 374298, lu le 2026-10-02) :
   - s'ouvre 15 s après le chargement de la page, sur toutes les pages, ordinateur et mobile ;
   - « Non merci », la croix, Échap ou un clic sur le voile : plus rien pendant la visite (session) ;
   - après l'inscription : plus jamais (365 jours), le code reste réaffichable par le lien #stp ;
   - le code est appliqué au panier (/discount/CODE), comme le faisait l'app.
   Inscription : formulaire newsletter natif de Shopify (/contact, form_type=customer) → client abonné.
   Code : « SW » + 8 caractères aléatoires (A-Z, 0-9), comme l'app. Il part dans un tag du nouveau
   client (« popup-code-SW… ») ; le workflow Shopify Flow « Popup Hawkins » le lit et crée la réduction.
   Un code n'est affiché que si Shopify confirme l'inscription d'un NOUVEAU client (?customer_posted=true) :
   c'est le seul cas où Shopify enregistre les tags, donc le seul où le code existera. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('stp-cfg'), tpl = document.getElementById('stp-tpl');
  if (!cfgEl || !tpl || window.__stpInit) return;
  try { if (window.top !== window.self) return; } catch (e) { return; }   /* jamais dans un cadre */
  window.__stpInit = true;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  /* ?stpopup=preview : s'ouvre tout de suite (tests) ; ?stpopup=demo : en plus, n'inscrit personne et ne crée rien. */
  var QS = (location.search.match(/[?&]stpopup=(preview|demo)\b/) || [])[1] || '';
  var testOk = !C.enabled || (window.Shopify && Shopify.designMode);
  C.preview = !!QS && testOk; C.demo = QS === 'demo' && testOk;
  var K_SUB = 'stp:sub', K_CODE = 'stp:code', K_SEEN = 'stp:seen';
  var HASHES = ['#stp', '#Ecomsend_popups_open_374298'];

  /* ---------- stockage tolérant (navigation privée, stockage bloqué) ---------- */
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ckGet(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }
  function ckSet(k, v, days) {
    try { document.cookie = k + '=' + encodeURIComponent(v) + '; max-age=' + (days * 86400) + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (e) {}
  }
  /* Inscrits via l'ancienne app EcomSend (popup 374298) : mêmes visiteurs, on ne les resollicite pas. */
  var LEGACY_SUB = 'ecomsend_pp_success_subscribed374298', LEGACY_CODE = 'ecomsend_discount_code374298';
  function subscribed() { return lsGet(K_SUB) === '1' || ckGet('stp_sub') === '1' || ckGet(LEGACY_SUB) === 'true' || !!ckGet(LEGACY_CODE); }
  function savedCode() { return lsGet(K_CODE) || ckGet('stp_code') || ckGet(LEGACY_CODE) || ''; }
  function markSubscribed(code) {
    lsSet(K_SUB, '1'); lsSet(K_CODE, code); ckSet('stp_sub', '1', 365); ckSet('stp_code', code, 365);
  }

  /* ---------- code : format exact de l'app (« SW-DAUKPF24PRFS72TC5720 ») ----------
     « SW- » + 20 caractères base32hex (0-9, A-V) : identifiant de type xid = horodatage (4 octets)
     + 8 octets aléatoires, encodés en 100 bits. Les codes de l'app suivent la même structure. */
  var B32 = '0123456789ABCDEFGHIJKLMNOPQRSTUV';
  function randomCode() {
    var bytes = new Uint8Array(12), t = Math.floor(Date.now() / 1000), i;
    bytes[0] = (t >>> 24) & 255; bytes[1] = (t >>> 16) & 255; bytes[2] = (t >>> 8) & 255; bytes[3] = t & 255;
    if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(bytes.subarray(4));
    else for (i = 4; i < 12; i++) bytes[i] = Math.floor(Math.random() * 256);
    var out = '', acc = 0, nb = 0;
    for (i = 0; i < 12; i++) { acc = (acc << 8) | bytes[i]; nb += 8; while (nb >= 5) { nb -= 5; out += B32.charAt((acc >>> nb) & 31); } acc &= (1 << nb) - 1; }
    if (nb > 0) out += B32.charAt((acc << (5 - nb)) & 31);
    return C.prefix + out;                                   /* 96 bits → 20 caractères */
  }

  /* ---------- interface ---------- */
  var root = null, card = null, lastFocus = null, timer = null, openState = false, cssReady = null;
  /* Halloween 2026 : habillage jusqu'au 30/10 23:59 (Paris, heure d'hiver), même date que snippets/st-halloween.liquid */
  var HW_END = Date.UTC(2026, 9, 30, 22, 59, 59);
  var PUMPKIN = '<svg viewBox="0 0 40 40" fill="none" aria-hidden="true"><path d="M20 11.6c-.9-2.7-.2-4.8 2-6.2" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><path d="M20 12.2c-3.3-2.1-9.6-1.7-12.5 3.3-2.7 4.7-1.7 11.6 2.4 15 3.1 2.6 7.1 2.9 10.1 1.4 3 1.5 7 1.2 10.1-1.4 4.1-3.4 5.1-10.3 2.4-15-2.9-5-9.2-5.4-12.5-3.3z" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round"/><g fill="currentColor"><path d="M12.6 22.2l3-4.3 3 4.3z"/><path d="M21.4 22.2l3-4.3 3 4.3z"/><path d="M12.8 25.4c4.5 3.6 9.9 3.6 14.4 0l-1.2 2.4-1.7-1-1.5 1.7-1.7-1.3-1.6 1.6-1.6-1.6-1.7 1.3-1.5-1.7-1.7 1z"/></g></svg>';
  /* Téléphone : panneau en bas d'écran, non modal (la page reste utilisable derrière) */
  function sheet() { return !!(window.matchMedia && matchMedia('(max-width: 749px)').matches); }
  function loadCss() {
    if (cssReady) return cssReady;
    cssReady = new Promise(function (res) {
      var l = document.createElement('link'), t = setTimeout(function () { res(false); }, 8000);
      l.rel = 'stylesheet'; l.href = C.css;
      l.onload = function () { clearTimeout(t); res(true); };
      l.onerror = function () { clearTimeout(t); res(false); };
      document.head.appendChild(l);
    });
    cssReady.then(function (ok) { if (!ok) cssReady = null; });
    return cssReady;
  }
  /* Bandeau de consentement ouvert (html.st-cc-open, posé par st-cookie-banner) : comme l'ancienne app,
     le popup attend que le visiteur ait fait son choix. */
  function afterConsent(fn) {
    if (!document.documentElement.classList.contains('st-cc-open')) return fn();
    var mo = new MutationObserver(function () {
      if (!document.documentElement.classList.contains('st-cc-open')) { mo.disconnect(); setTimeout(fn, 400); }
    });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  function $(sel) { return root ? root.querySelector(sel) : null; }
  function build() {
    if (root) return;
    var frag = document.importNode(tpl.content, true);
    root = frag.querySelector('.stp');
    document.body.appendChild(frag);
    card = root.querySelector('.stp__card');
    if (Date.now() <= HW_END) {
      root.classList.add('stp--hw');
      var hk = document.createElement('p'); hk.className = 'stp__hwk'; hk.setAttribute('aria-hidden', 'true'); hk.innerHTML = PUMPKIN + 'Halloween';
      var st0 = root.querySelector('[data-step="start"]'); if (st0) st0.parentNode.insertBefore(hk, st0);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-stp-close]')) { e.preventDefault(); close(); }
    });
    root.querySelector('.stp__form').addEventListener('submit', onSubmit);
    root.querySelector('[data-stp-copy]').addEventListener('click', onCopyAndClose);
    root.querySelector('[data-stp-copyicon]').addEventListener('click', function () { copy(); });
    var inp = root.querySelector('.stp__input');
    inp.addEventListener('input', function () { showErr(''); });
    inp.addEventListener('focus', function () { prepare(); });
    document.addEventListener('keydown', onKey, true);
  }
  function focusables() {
    return Array.prototype.filter.call(card.querySelectorAll('button,input:not([tabindex="-1"]),a[href],[tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; });
  }
  function onKey(e) {
    if (!openState) return;
    if (document.documentElement.classList.contains('st-cc-open')) return;   /* popup masqué : clavier libre */
    var ae = document.activeElement;
    if (ae && ae.closest && ae.closest('#shopify-pc__banner,#shopify-pc__prefs')) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab' || sheet()) return;
    var f = focusables(); if (!f.length) { e.preventDefault(); card.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !card.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !card.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }
  function step(name) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-step]'), function (s) { s.hidden = s.getAttribute('data-step') !== name; });
    card.setAttribute('aria-labelledby', 'stp-title-' + name);
    card.setAttribute('aria-describedby', 'stp-desc-' + name);
  }
  function open(name, code, err) {
    if (openState) return;
    afterConsent(function () { reveal(name, code, err); });
  }
  function reveal(name, code, err) {
    if (openState) return;
    loadCss().then(function (ok) {
      if (openState || !ok) return;
      build();
      if (getComputedStyle(root).position !== 'fixed') return;           /* styles absents : on ne montre rien */
      if (name === 'ok') fillCode(code); else showErr(err || '');
      step(name);
      lastFocus = document.activeElement;
      card.setAttribute('aria-modal', sheet() ? 'false' : 'true');
      root.classList.remove('is-out'); root.hidden = false; openState = true;
      setTimeout(function () {
        var t = name === 'ok' ? $('[data-stp-copy]') : (sheet() ? card : $('.stp__input'));
        try { (t || card).focus({ preventScroll: true }); } catch (e) { (t || card).focus(); }
      }, 30);
    });
  }
  function close() {
    if (!openState) return;
    openState = false;
    ssSet(K_SEEN, '1');
    root.classList.add('is-out');
    var done = function () { root.hidden = true; root.classList.remove('is-out'); };
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) done(); else setTimeout(done, 200);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function showErr(msg) {
    var box = $('.stp__err'), input = $('.stp__input');
    if (!box) return;
    var span = box.querySelector('span');
    span.textContent = '';
    box.hidden = !msg;
    if (input) {
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (msg) input.setAttribute('aria-describedby', 'stp-err'); else input.removeAttribute('aria-describedby');
    }
    if (msg) setTimeout(function () { span.textContent = msg; }, 40);   /* réannoncé même si le texte est identique */
  }
  function fitCode() {
    var el = $('.stp__code'); if (!el) return;
    el.style.fontSize = '';
    var fs = parseFloat(getComputedStyle(el).fontSize) || 18, n = 0;
    while (el.scrollWidth > el.clientWidth && fs > 11 && n++ < 20) { fs -= 0.5; el.style.fontSize = fs + 'px'; }
  }
  function fillCode(code) {
    $('.stp__code').value = code;
    setTimeout(fitCode, 0);
    var lab = $('[data-stp-label]'); if (lab) lab.textContent = C.t.label;
  }
  function busy(on) {
    var b = $('.stp__form .stp__btn'); if (!b) return;
    if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    b.disabled = !!on;
  }
  function applyDiscount(code) {
    try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {}); } catch (e) {}
  }
  var EMAIL_RX = /^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

  /* ---------- inscription ----------
     Formulaire newsletter natif (/contact, form_type=customer), protégé par le captcha de Shopify avec
     window.Shopify.captcha.protect — la méthode officielle pour un formulaire ajouté après le chargement.
     La protection remplace form.submit par : captcha invisible → jeton h-captcha-response → appel de
     l'envoi « d'origine », capturé au moment du branchement. Cet envoi d'origine est le nôtre (posé
     AVANT protect) : un fetch qui lit la réponse de Shopify, donc pas de rechargement de page.
     Règles de sûreté : jamais d'envoi sans jeton (Shopify répond 400) ; jamais de navigation vers une
     page d'erreur ; on attend tant qu'un défi hCaptcha est affiché ; un code n'est montré QUE si Shopify
     confirme l'inscription d'un nouveau client (?customer_posted=true sur NOTRE adresse de retour). */
  var hf = null, hfBound = false, pending = null;
  function prepare() {
    if (hf || C.demo) return;
    hf = document.createElement('form');
    hf.method = 'post'; hf.action = C.action; hf.setAttribute('accept-charset', 'UTF-8'); hf.style.display = 'none';
    [['form_type', 'customer'], ['utf8', '✓'], ['contact[email]', ''], ['contact[tags]', '']].forEach(function (p) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = p[0]; i.value = p[1]; hf.appendChild(i);
    });
    document.body.appendChild(hf);
    hf.submit = function () { viaFetch(); };                 /* l'« envoi d'origine » que la protection rappellera */
    try {
      if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') {
        Shopify.captcha.protect(hf, function () { hfBound = hf.hasAttribute('data-hcaptcha-bound'); });
      }
    } catch (e) {}
  }
  function waitBound(ms) {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function tick() { if (hfBound && hf.hasAttribute('data-hcaptcha-bound')) return res(true); if (Date.now() - t0 > ms) return res(false); setTimeout(tick, 100); })();
    });
  }
  /* Défi hCaptcha interactif à l'écran : on ne coupe jamais l'attente pendant que le visiteur le résout. */
  function challengeOpen() {
    var f = document.querySelectorAll('iframe[src*="hcaptcha"]');
    for (var i = 0; i < f.length; i++) {
      if (!/challenge/.test(f[i].src)) continue;
      var r = f[i].getBoundingClientRect(), cs = getComputedStyle(f[i].parentNode || f[i]);
      if (r.width > 40 && r.height > 40 && cs.visibility !== 'hidden' && cs.display !== 'none') return true;
    }
    return false;
  }
  function settle(r) { if (pending) { var p = pending; pending = null; clearInterval(p.watch); clearTimeout(p.deadline); p.done(r); } }
  function viaFetch() {
    if (!pending || pending.sent) return;
    pending.sent = true;
    var mine = pending, code = mine.code;
    /* Réseau bloqué après l'envoi : au bout de 25 s on rend la main (message de l'app). Si la réponse
       arrive plus tard et confirme l'inscription, le code est quand même montré : il existera. */
    mine.deadline = setTimeout(function () { mine.late = true; settle({ fail: true }); }, 25000);
    var fd = new FormData(hf);
    fetch(C.action, { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'follow',
                      referrer: location.origin + location.pathname, referrerPolicy: 'same-origin' }).then(function (res) {
      var url = res.url || '';
      if (mine.late) { if (/customer_posted=true/.test(url)) success(code); return; }
      if (/customer_posted=true/.test(url)) return settle({ ok: true });
      if (/\/challenge/.test(url)) return settle({ challenge: true });
      if (res.status === 400) return settle({ retry: true });
      if (res.ok && res.redirected) return settle({ already: true });   /* renvoyé sur la page sans succès : e-mail déjà connu */
      settle({ fail: true });
    }).catch(function () { settle({ fail: true }); });
  }
  function send(email, code, attempt) {
    hf.elements['contact[email]'].value = email;
    hf.elements['contact[tags]'].value = C.tags + ',popup-code-' + code;
    return new Promise(function (done) {
      var t0 = Date.now(), seen = false, gone = 0;
      pending = { done: done, code: code, sent: false, watch: setInterval(function () {
        if (!pending || pending.sent) return;
        if (challengeOpen()) { seen = true; gone = 0; t0 = Date.now(); return; }   /* défi en cours : on attend */
        if (seen && !gone) gone = Date.now();
        if (seen && Date.now() - gone > 4000) return settle({ fail: true });    /* défi refermé sans réponse (4 s : le temps que hCaptcha valide une réponse) */
        if (Date.now() - t0 > 45000) settle({ fail: true });
      }, 250) };
      hf.submit();                                                /* = la protection Shopify (captcha puis notre fetch) */
    }).then(function (r) {
      /* Jeton refusé : un nouveau, une fois. Pause de 400 ms : la protection Shopify ignore un second
         appel de form.submit() survenant moins de 250 ms après le précédent. */
      if (r.retry && attempt < 2) return new Promise(function (ok) { setTimeout(ok, 400); }).then(function () { return send(email, code, attempt + 1); });
      if (r.retry) return { fail: true };
      return r;
    });
  }
  function onSubmit(e) {
    e.preventDefault();
    if (pending) return;
    var form = e.currentTarget, input = $('.stp__input');
    var email = (input.value || '').trim();
    if (form.querySelector('.stp__hp').value) return;                      /* robot */
    if (!EMAIL_RX.test(email) || email.length > 254) { showErr(C.t.invalid); input.focus(); return; }
    showErr(''); busy(true);
    Promise.resolve(C.demo ? C.prefix + 'DEMO0000000000000000' : randomCode()).then(function (code) {
      if (C.demo) { setTimeout(function () { busy(false); success(code, true); }, 600); return; }
      prepare();
      return waitBound(15000).then(function (ok) {
        if (!ok) { busy(false); showErr(C.t.fail); return; }                 /* captcha Shopify injoignable : rien n'est envoyé */
        return send(email, code, 1).then(function (r) {
          if (r.ok) { busy(false); success(code); }
          else if (r.already) { busy(false); showErr(C.t.already); }
          else { busy(false); showErr(C.t.fail); }
        });
      });
    }).catch(function () { pending = null; busy(false); showErr(C.t.fail); });
  }
  function success(code, demo) {
    if (!demo) { markSubscribed(code); applyDiscount(code); }
    if (!openState) { busy(false); reveal('ok', code); return; }   /* fermé pendant l'envoi : on montre quand même le code */
    step('ok'); fillCode(code);
    setTimeout(function () { var b = $('[data-stp-copy]'); if (b) { try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); } } }, 30);
  }

  /* ---------- copie du code ---------- */
  function copy() {
    var input = $('.stp__code'), code = input.value, live = $('.stp__live');
    var done = function () { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = C.t.copied; }, 30); } return true; };
    var legacy = function () {
      try { input.focus(); input.select(); input.setSelectionRange(0, code.length); if (document.execCommand('copy')) return done(); } catch (e) {}
      return false;
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(code).then(done, function () { return legacy(); });
    }
    return Promise.resolve(legacy());
  }
  function onCopyAndClose() {
    var b = $('[data-stp-copy]'), lab = b.querySelector('span');
    copy().then(function (ok) {
      if (ok) lab.textContent = C.t.copied;
      if (!C.demo) applyDiscount($('.stp__code').value);
      setTimeout(function () { close(); lab.textContent = C.t.copy; }, ok ? 900 : 0);
    });
  }

  /* ---------- déclenchement ---------- */
  function hashOpen() {
    if (HASHES.indexOf(location.hash) < 0) return false;
    var code = savedCode();
    if (subscribed() && code) open('ok', code); else open('start');
    try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {}
    return true;
  }
  function eligible() {
    if (window.Shopify && Shopify.designMode && !C.preview) return false;
    if (/\/(challenge|password|checkouts?)(\/|$)/.test(location.pathname)) return false;
    if (subscribed() && !C.preview) return false;
    if (ssGet(K_SEEN) === '1' && !C.preview) return false;
    return true;
  }
  function init() {
    if (/\/challenge(\/|$)/.test(location.pathname)) return;        /* page de défi Shopify : ne rien consommer */
    /* Une inscription par un autre formulaire vient de réussir (newsletter du pied de page ou de l'accueil) :
       on ne propose pas le popup pendant cette visite. */
    if (/customer_posted=true/.test(location.search)) ssSet(K_SEEN, '1');
    if (!C.enabled && !C.preview) return;
    window.addEventListener('hashchange', hashOpen);
    if (hashOpen()) return;
    if (!eligible()) return;
    var delay = C.preview ? 0 : Math.max(0, C.delay) * 1000;
    timer = setTimeout(function () { if (eligible() || C.preview) open('start'); }, delay);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
